module.exports = __webpack_public_path__ + "static/media/Kpos1.26d0af61.png";